import { useMemo, useState } from "react";
import { trendingVideos, videoCategories } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function TrendingVideos() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () =>
      active === "全部"
        ? trendingVideos
        : trendingVideos.filter((item) => item.category === active),
    [active],
  );

  return (
    <section id="videos" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="视频资源"
          icon="ri-play-circle-line"
          title="色虎视频在线观看 · 本周热门"
          desc="按主题整理近期关注度较高的视频资源，包含自然风光、人文纪实、城市影像与生活美学等方向。点击下方标签即可在本页筛选，卡片标注时长与画质信息。"
        />

        <div className="mb-7 flex flex-wrap gap-2" role="tablist" aria-label="视频分类筛选">
          {videoCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              role="tab"
              aria-selected={active === cat}
              onClick={() => setActive(cat)}
              className={`px-4 py-2 rounded-full text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                active === cat
                  ? "bg-primary-600 border-primary-600 text-background-50 font-medium"
                  : "bg-background-50 border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((video) => (
            <article
              key={video.id}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="relative h-[180px] overflow-hidden bg-foreground-900">
                <img
                  src={video.cover}
                  alt={`色虎视频资源：${video.title}`}
                  title={`${video.title} 在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-[11px]">
                  {video.category}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-[11px] flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {video.duration}
                </span>
                <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug">
                  {video.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600 flex-1">
                  {video.desc}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line"></i>
                    {video.views} 次浏览
                  </span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium">
                    观看
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}